import { FunSun } from './config';

export const isFunSun = (providerClass: string) => {
  return providerClass === FunSun;
};
